import { BarcodeScanner } from '@awesome-cordova-plugins/barcode-scanner/ngx';
import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { PhotoViewer } from '@awesome-cordova-plugins/photo-viewer/ngx';
import { PipesModule } from './pipes/pipes.module';
import { authInterceptorProvider } from './interceptors/auth.interceptor';
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { QRCodeComponent } from 'angularx-qrcode';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {ComponentsModule} from './components/components.module';
import { IonicStorageModule } from '@ionic/storage';
import { SpinnerInterceptor } from './interceptors/spinner.interceptor';
import localeEsMx from '@angular/common/locales/es-MX';
import { registerLocaleData } from '@angular/common';
import { BLE } from '@awesome-cordova-plugins/ble/ngx';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { NgxEchartsModule } from 'ngx-echarts';
import { BackgroundMode } from '@awesome-cordova-plugins/background-mode/ngx';

// import { Health } from '@awesome-cordova-plugins/health/ngx';

registerLocaleData(localeEsMx,'es-MX');
@NgModule({ declarations: [AppComponent],
    //entryComponents: [],
    bootstrap: [AppComponent], imports: [BrowserModule, ComponentsModule,
        IonicModule.forRoot(), AppRoutingModule, PipesModule, QRCodeComponent,
        ComponentsModule, BrowserAnimationsModule, IonicStorageModule.forRoot(),
        NgxEchartsModule.forRoot({
            echarts: () => import('echarts')
        })], providers: [
        { provide: LOCALE_ID, useValue: 'es-MX' },
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        PhotoViewer,
        FileOpener, File, //Health,
        { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },
        SplashScreen, StatusBar, ScreenOrientation, authInterceptorProvider,        //  Health
        BLE, BarcodeScanner, BackgroundMode, 
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {}
